import CorvinArt from '../brand/CorvinArt';

// Replaces the generic spinner while an AI request runs. Static on purpose:
// the spec allows only a blink and a settle, and no pulse.
export default function CorvinThinking({ label = 'Corvin is working on it.', size = 72 }) {
  return (
    <div role="status" aria-live="polite" className="flex flex-col items-center justify-center gap-2 p-8 text-center">
      <CorvinArt pose="thinking" size={size} />
      <p className="text-small text-ink-muted">{label}</p>
    </div>
  );
}
